<template>
  <div v-if="!loading" class="main-content">
    <div class="tickets-title">Tickets</div>
    <div class="tickets-subtitle">Choose the event you want to sell tickets for.</div>
    <text-field
      label="Search orders"
      class="searchBar"
      append-icon="search"
      @input="onInputChange"
    />
    <div v-if="events.length" class="tickets-content">
      <div v-for="event in filteredEvents" :key="event.id" class="card-container">
        <event-card :event="event" />
      </div>
    </div>
    <div v-else class="tickets-no-content">
      <img class="no-content-image" src="/assets/no-tickets.svg" alt="no tickets" />
      <p class="no-content-description">Unfortunately, there are no events available right now.</p>
    </div>
  </div>
</template>

<script>
import EventCard from './event-card.vue'
import { GET_TICKET_SELLERS_EVENTS } from '../../../graphql/event.graphql'
import { OrganizationType } from '@/types'

export default {
  components: { EventCard },
  data() {
    return {
      events: [],
      filteredEvents: [],
      loading: true,
    }
  },
  methods: {
    onInputChange: function (term) {
      const t = term.trim().toLowerCase()
      this.filteredEvents = this.events.filter(e => {
        return e.title.toLowerCase().includes(t)
      })
    },
  },
  apollo: {
    getTicketSellersEvents: {
      query: GET_TICKET_SELLERS_EVENTS,
      async result({ data, loading }) {
        if (!loading) {
          this.events = data.getTicketSellersEvents.filter(e => {
            if (e.organization.type !== OrganizationType.THEATER && !!e.audienceCapacity) {
              return e.applicationsOpen && !!e.numOfRemainingTickets
            }

            return e.applicationsOpen
          })
          this.filteredEvents = this.events
          this.loading = false
        }
      },
    },
  },
}
</script>

<style scoped>
.main-content {
  max-width: 676px;
}

.tickets-title {
  color: #ff4c00;
  font-size: 2.25rem;
  font-weight: 800;
  font-family: 'Raleway', 'sans-serif';
  line-height: 120%;
  letter-spacing: -0.03em;
}

.tickets-subtitle {
  color: #666666;
  font-size: 0.875rem;
  line-height: 150%;
  margin-top: 0.875rem;
  margin-bottom: 1.75rem;
}

.card-container {
  margin-bottom: 1rem;
}

.tickets-no-content {
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.no-content-description {
  margin-top: 1rem;
  color: #ff4c00;
  font-size: 1.25rem;
  font-weight: 600;
  font-family: 'Raleway', 'sans-serif';
  line-height: 120%;
  letter-spacing: -0.03em;
  text-align: center;
}

@media only screen and (max-width: 1112px) {
  .main-content {
    margin-right: 1.875rem;
  }
}

@media only screen and (max-width: 800px) {
  .main-content {
    margin-right: 0;
  }
}
.searchBar {
  background: #f5f5f5;
  border-bottom: 1px solid #d9d9d9;
  border-radius: 4px 4px 0px 0px;
  height: 56px;
  margin-bottom: 32px;
}
</style>
